<template>
    <section class="headGrp headGrpSO">
        <div class="digBanner"><a href="https://jointex.meclib.jp/library/books/ichioshi_31/book/"
        target="_blank"><img class="pc" :src="img_common_path + digital_banner" alt="カタログデジカタバナー"></a></div>
        <div class="wrap01 centerHH">
            <h2 class="header_title">
                <img class="pc" :src="img_common_path + header_title" alt="オススメの家具を厳選！イチオシ家具">
                <img class="sp" :src="img_common_path + header_title_sp" alt="オススメの家具を厳選！イチオシ家具">
                <!-- <img class="h-full" :src="img_common_path + Home_Top_Img"> -->
                <!-- <p class="text-txt-white pl-200 -mt-4 text-sm font-bold">（一部エリア・一部商品を除く）詳しくは「<span
                        class="underline cursor-pointer" @click="toDelivery">納品について</span>」をご覧ください。</p> -->
            </h2>
        </div>
        <!-- <div class="entriesList">
            <h4 class="entriesList_title">
                各ユーザー様向けサイトのイチオシ家具はこちらから
            </h4>
            <div class="entriesList_title_triangle"></div>
        </div> -->

    </section>
</template>

<script>
export default {
    setup() {
        const img_common_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/common/"
        const Home_Top_Img = "Home_Top_img.svg"
        const header_title = "header_title.png"
        const header_title_sp = "header_title_sp.png"
        const digital_banner = "digital_banner_vol31.png"

        // スクロールするやつ
        async function toDelivery() {
            const element = document.getElementById('toDelivery')
            const position = element.getBoundingClientRect().top

            window.scrollTo({
                top: position,
                behavior: 'smooth'
            })
        }
        toDelivery()


        return {
            img_common_path,
            Home_Top_Img,
            header_title,
            header_title_sp,
            digital_banner,
            toDelivery
        }
    }

}
</script>